module.exports = __webpack_public_path__ + "img/icn_check_hv_tsumekiri.ded9490b.png";